// extracted by mini-css-extract-plugin
export var accordion = "style-mod--accordion--d67ce";
export var button = "style-mod--button--d69e5";
export var errorMsg = "style-mod--error-msg--ba050";
export var input = "style-mod--input--fa153";
export var inputs = "style-mod--inputs--83a1e";
export var orderByEmailWrapper = "style-mod--order-by-email-wrapper--ae693";
export var title = "style-mod--title--56b9f";